// extracted by mini-css-extract-plugin
export default {"base":"Link_base__kn+Z9"};